const Filter = ({countries, handleClick}) => {
    const handleFilter = (event) => {
        handleClick(event.target.value);
    }
    return (
        <div className="filter-div">
            <select name="region" onChange={handleFilter} id="region">
                <option value="all">Filter by Region</option>
                <option value="Africa">Africa</option>
                <option value="Americas">America</option>
                <option value="Asia">Asia</option>
                <option value="Europe">Europe</option>
                <option value="Oceania">Oceania</option>
            </select> 
        </div>)
}
export default Filter;